import { snakeCase, toUpper } from "lodash";

export function makeEnum(values) {
  let obj = Object.create(null);
  for (let val of values) {
    obj[toUpper(snakeCase(val))] = Symbol(val);
  }
  return Object.freeze(obj);
}
